import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "@/components/site/Hero";
import LogoMarquee from "@/components/site/LogoMarquee";
import Belief from "@/components/site/Belief";
import Platform from "@/components/site/Platform";
import Preparation from "@/components/site/Preparation";
import MidDivider from "@/components/site/MidDivider";
import Founder from "@/components/site/Founder";
import Portfolio from "@/components/site/Portfolio";
import Testimonials from "@/components/site/Testimonials";
import { scrollToId } from "@/components/site/SmoothScroll";

export default function Home() {
  const location = useLocation();

  // Consume a pending anchor passed via navigation state (e.g. from an operator
  // profile or a cross-route nav link). Runs once on mount (Home remounts per
  // route change). Waits until BOTH the target's absolute offset AND the full
  // page height are stable (downstream sections + images have laid out) before
  // letting Lenis scroll, with a safety retry for late shifts.
  useEffect(() => {
    const target = location.state?.scrollTo;
    if (!target) return;
    // Clear the navigation state WITHOUT triggering a react-router re-render
    // (navigate() here would re-run this effect and cancel its own rAF loop).
    window.history.replaceState({ ...window.history.state, usr: {} }, "");

    let raf;
    let tries = 0;
    let lastTop = -1;
    let lastH = -1;
    let stable = 0;

    const doScroll = () => scrollToId(target, { offset: -80 });

    const tick = () => {
      const el = document.getElementById(target);
      const h = document.body.scrollHeight;
      if (el) {
        const top = Math.round(el.getBoundingClientRect().top + window.scrollY);
        if (top === lastTop && h === lastH) stable += 1;
        else {
          stable = 0;
          lastTop = top;
          lastH = h;
        }
        if (stable >= 5) {
          doScroll();
          // safety retry if a late layout shift left the target off-screen
          setTimeout(() => {
            const el2 = document.getElementById(target);
            if (el2 && Math.abs(el2.getBoundingClientRect().top - 80) > 240) doScroll();
          }, 700);
          return;
        }
      }
      if (tries++ < 240) raf = requestAnimationFrame(tick);
      else doScroll();
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
    // Mount-only: Home remounts on each route change (AnimatePresence key=pathname),
    // so location.state is fresh each mount. Re-running on state change would
    // cancel the rAF loop before it settles.
  }, []);

  return (
    <>
      <main>
        <Hero />
        <LogoMarquee />
        <Belief />
        <Preparation />
        <Platform />
        <Founder />
        <Portfolio />
        <Testimonials />
        <MidDivider />
      </main>
    </>
  );
}
